import { useMemo } from 'react'
import useDynamicSearchParam from './useDynamicSearchParam'
import useUser from './useUser'

export function useTopResumeUpload(): {
  leadEmailExists: boolean
} {
  const { email, isLoading } = useUser()
  const emailQueryParam = useDynamicSearchParam('email')

  const leadEmailExists =
    !isLoading && [email, emailQueryParam].some((val) => Boolean(val))

  return useMemo(
    () => ({
      leadEmailExists,
    }),
    [leadEmailExists]
  )
}
